import { PlanPrices } from '../utils/prices';

interface PromoConfig {
  displayBanner: boolean;
  bannerLink: string;
  headerDescription: string;
  buttonText?: string;
}

type PromoNames =
  | 'amazon_1year'
  | 'amazon_3months'
  | 'worldstrides_3m_max'
  | 'default';

// eslint-disable-next-line import/prefer-default-export
export function getPromoUIMap(plans: PlanPrices): {
  default: {
    standard: { pricingMessage: string };
    max: { pricingMessage: string };
    invest: { pricingMessage: string };
    displayBanner: boolean;
    bannerLink: string;
    headerDescription: string;
  };
  amazon_1year: {
    standard: { pricingMessage: string };
    max: { pricingMessage: string };
    invest: { pricingMessage: string };
    displayBanner: boolean;
    bannerLink: string;
    headerDescription: string;
  };
  amazon_3months: {
    standard: { pricingMessage: string };
    buttonText: string;
    max: { pricingMessage: string };
    invest: { pricingMessage: string };
    bannerLink: string;
    displayBanner: boolean;
    headerDescription: string;
  };
  worldstrides_3m_max: {
    max: { pricingMessage: string };
    displayBanner: boolean;
    bannerLink: string;
    headerDescription: string;
  };
} {
  return {
    amazon_1year: {
      max: {
        pricingMessage: `After your first month, you’ll only pay $${plans.standard}/mo. for the rest of your first year as an Amazon customer, After that, our Max plan is`
      },
      invest: {
        pricingMessage:
          'After your first month, you’ll only pay $2.99/mo. for the rest of your first year as an Amazon customer. After that, our Invest plan is'
      },
      standard: {
        pricingMessage: 'After your 12 month free trial, your plan is'
      },
      displayBanner: false,
      bannerLink: '',
      headerDescription: `After your first 12 free months, it’s $${plans.standard}/month — which includes debit cards for up to 5 kids.`
    },
    amazon_3months: {
      max: {
        pricingMessage: `After your free month, your promo Max plan will be $${plans.standard} for 2 months, then regular price of`
      },
      invest: {
        pricingMessage:
          'After your free month, your promo Invest plan will be $2.99 for 2 months, then regular price of'
      },
      standard: {
        pricingMessage: 'After your 3 month free trial, your plan is'
      },
      buttonText: 'Continue with 3 months free',
      bannerLink: 'https://www.amazon.com/b?node=23673205011',
      displayBanner: true,
      headerDescription: `After your first 3 free months, it’s $${plans.standard}/month — which includes debit cards for up to 5 kids.`
    },
    worldstrides_3m_max: {
      max: {
        pricingMessage:
          'After your 3 free months of Greenlight Max, your plan is'
      },
      displayBanner: false,
      bannerLink: '',
      headerDescription: ''
    },
    default: {
      max: {
        pricingMessage: 'After your 1 month free trial, your plan is'
      },
      invest: {
        pricingMessage: 'After your 1 month free trial, your plan is'
      },
      standard: {
        pricingMessage: 'After your 1 month free trial, your plan is'
      },
      displayBanner: false,
      bannerLink: '',
      headerDescription: `The debit card for kids and money app for families. After your 1-month free trial, Greenlight plans start at just $${plans.standard}/month.  All plans cover the whole family, up to 5 kids.`
    }
  };
}
